import ExcelJs from 'exceljs'

import { productProblemsMap } from '../interfaces/productProblemsEnum'
import { CleanReport } from '../services/reportServices'

export async function exportToExcel(data: CleanReport[], fileName: string) {
  const workbook = new ExcelJs.Workbook()
  const worksheet = workbook.addWorksheet('Relatório')

  const headers = [
    'ID do Relatório',
    'Grupo',
    'Loja',
    'Estado',
    'Cidade',
    'Data da Última Atualização',
    'Observações do Gerente',
    'Sugestões de Melhorias',
    'Observações Gerais',
    'Produtos com Problema',
  ]

  worksheet.addRow(headers)

  headers.forEach((_, colIndex) => {
    const cell = worksheet.getCell(1, colIndex + 1)
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFCC00' } }
    cell.font = { bold: true, color: { argb: 'FF000000' } }
    cell.alignment = { horizontal: 'center' }
  })

  data.forEach(report => {
    const row = worksheet.addRow([
      report.id,
      report.store.group.name,
      report.store.name,
      report.store.state,
      report.store.city,
      new Date(report.updated_at).toLocaleString('pt-BR'),
      report.manager_observations || '---',
      report.improvement_suggestions || '---',
      report.general_observations || '---',
      report.report_product_problem.length > 0
        ? report.report_product_problem.map(p => `${productProblemsMap[p.problem]} - ${p.product.code}, ${p.product.name}`).join('\n')
        : 'Nenhum',
    ])

    row.getCell(1).alignment = { horizontal: 'left' }
    row.getCell(6).alignment = { horizontal: 'right' }
    row.getCell(10).alignment = { wrapText: true }
  })

  worksheet.columns.forEach(col => {
    const colValues = col.values as string[]
    const validValues = colValues.filter(value => value !== undefined && value !== null)
    const maxLength = Math.max(...validValues.map(value => value.length))
    col.width = Math.min(Math.max(maxLength, 20), 70) + 5
  })

  worksheet.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: data.length + 1, column: headers.length },
  }

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${fileName}.xlsx`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
